
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPageFirstGoogle as ObiPageFirstGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-page-first-google.js';
 
 
 

 
 export const ObiPageFirstGoogle = createComponent({
   react: React,
   tagName: 'obi-page-first-google',
   elementClass: ObiPageFirstGoogleElement,
   events: {
     
   }
  });
 
 